import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { AuthProvider } from './auth'
import { RootErrorBoundary } from './components/RootErrorBoundary'
import './index.css'

// Predictions change slowly and every page polls on its own interval, so refetching on window focus
// would be pure noise against the API for no visible benefit.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, staleTime: 30_000, retry: 1 },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RootErrorBoundary>
      <QueryClientProvider client={queryClient}>
        {/* Inside the query provider, because resolving the signed-in user is itself a query.
            Outside App, because the fantasy pages are not the only thing that will eventually want
            to know who is reading. */}
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </RootErrorBoundary>
  </StrictMode>,
)
